import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
import { SwiperModule } from "swiper/types/shared";
import { NavigationOptions } from "swiper/types/modules/navigation";
import { PaginationOptions } from "swiper/types/modules/pagination";

export class SwiperComponent extends HTMLElement {
	public static NAME = "swiper-component";

	#loop: boolean;
	#modules: SwiperModule[];
	#prevEl: HTMLElement;
	#nextEl: HTMLElement;
	#navigation: NavigationOptions;
	#pagination?: PaginationOptions;
	#paginationEl: HTMLElement;
	#speed: number;
	#swiper: Swiper;

	connectedCallback(): void {
		this.#modules = [];
		this.#speed = parseInt(this.dataset.swiperSpeed) || 500;
		this.#loop = this.hasAttribute("data-swiper-loop");
		this.#nextEl = this.querySelector(".swiper-button-next");
		this.#prevEl = this.querySelector(".swiper-button-prev");
		this.#paginationEl = this.querySelector(".swiper-pagination");
		this.#initSwiper();
	}

	disconnectedCallback(): void {
		this.#swiper.destroy();
	}

	#setModules = () => {
		if (this.#nextEl && this.#prevEl) {
			this.#modules.push(Navigation);
			this.#navigation = {
				enabled: true,
				nextEl: this.#nextEl,
				prevEl: this.#prevEl,
			};
		}
		if (this.#paginationEl) {
			this.#modules.push(Pagination);
			this.#pagination = {
				enabled: true,
				el: this.#paginationEl,
				clickable: true,
				bulletClass: `swiper-pagination-bullet`,
				bulletActiveClass: `swiper-pagination-bullet-active`,
				bulletElement: this.#paginationEl.nodeName.match("OL|UL")
					? "li"
					: "span",
			};
		}
	};

	#initSwiper = () => {
		this.#setModules();

		this.#swiper = new Swiper(
			this.querySelector(".swiper") as HTMLElement,
			{
				loop: this.#loop,
				modules: this.#modules,
				navigation: this.#navigation,
				pagination: this.#pagination,
				slidesPerView: "auto",
				speed: this.#speed,
			},
		);
	};
}

customElements.define(SwiperComponent.NAME, SwiperComponent);
